<div id="layout-wrapper">

  <app-navbar></app-navbar>
  <app-sidebar></app-sidebar>

  <div class="main-content">
    <div class="page-content">
        <div class="container-fluid">
            <router-outlet></router-outlet>
        </div>
        <!-- container-fluid -->
    </div>
    <!-- End Page-content -->
</div>

</div>